<template>
  <b-media
    class="notification-card "
    :class="(!notification.isRead && unReadNotifications!=0) && 'notification-card--active'"
  >
    <template #aside>
      <b-avatar
        size="42"
        :variant="displayNotification.type"
        :src="getAvatar(displayNotification.avatar)"
      >
        <feather-icon
          v-if="!displayNotification.avatar"
          :icon="displayNotification.icon"
        />
      </b-avatar>
    </template>
    <p class="media-heading d-flex align-items-center mb-0">
      <span class="font-weight-bolder">
        {{ displayNotification.title }}
      </span>
      <feather-icon
        v-if="!notification.isRead && unReadNotifications!=0"
        icon="CircleIcon"
        size="8"
        fill="#3D61AD"
        class="ml-1 text-primary"
      />
    </p>
    <small
      class="notification-text"
      v-html="displayNotification.subtitle"
    />
    <div class="text-right">
      <small class="text-mute">
        {{ fromNow(UTCtoLocal(displayNotification.createdAt)) }}
      </small>
    </div>
  </b-media>
</template>
<script>
import { BMedia, BAvatar } from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BMedia,
    BAvatar,
  },
  props: {
    notification: {
      type: [Array, Object],
      default: () => {},
    },
    unReadNotifications: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      currentUser: getUserData(),
    }
  },
  computed: {
    displayNotification() {
      const {
        isRead, uuid, createdAt, notification,
      } = this.notification
      const displayUser = notification.member.uuid === this.currentUser.uuid ? 'you' : `${notification.member.name}`
      const creatorName = notification.addedBy.uuid === this.currentUser.uuid ? 'You have' : `${notification.addedBy.name} has`
      let displayAvatar = notification.member.avatar
      if (notification.member.uuid === this.currentUser.uuid) {
        displayAvatar = notification.addedBy.avatar
      }

      const title = 'Board Member Added!'
      const subtitle = `${creatorName} added "${displayUser}" to the board <strong>"${notification.board.name}"</strong>.`
      return {
        title, subtitle, type: 'light-success', icon: 'UserIcon', avatar: displayAvatar, isRead, uuid, createdAt,
      }
    },
  },
}
</script>
